<img src="assets/zlogo.svg" alt="PIMS Logo" class="absolute top-8 left-8 w-24" />

<div class="flex flex-col items-center text-center">
  <img src="/reset-password.png" alt="Reset Password" class="mb-6 w-44" />
  <h2 class="mb-2 text-2xl font-bold" i18n="@@resetPasswordTitle">Reset Password</h2>
  <p class="mt-2 max-w-md text-gray-600" i18n="@@resetPasswordDescription">
    Your new password must be at least 8 characters and contain one digit, one English letter, and one special
    character.
  </p>
</div>
